import type { RouteConfig } from 'vue-router';

export default [
  /**
   * 审核结果包含三个状态：审核中，手动刷新，出额成功
   */
  {
    path: '/assessment',
    meta: {
      title: '审核结果',
      background: '#fff',
    },
    component: () => import('@/views/assessment/index.vue'),
  },
  /**
   * 审核结果为额度冻结
   */
  {
    path: '/assessment/frozen',
    meta: {
      title: '审核结果',
      background: '#fff',
      customNavBar: true,
    },
    component: () => import('@/views/assessment/frozen/index.vue'),
  },
  /**
   * 审核未通过/强拒贷
   */
  {
    path: '/assessment/rejected',
    meta: {
      title: '审核结果',
      background: '#F5F5F5',
      customNavBar: true,
    },
    component: () => import('@/views/assessment/rejected.vue'),
  },
  /**
   * 审核未通过/强拒贷-推荐
   * 除宜享花在使用外，商城私域流量也会导流到此页面
   */
  {
    path: '/assessment/rejected/recommend',
    meta: {
      title: '我的额度',
      excludeTracking: true,
      background: '#F5F6FA',
      customNavBar: true,
    },
    component: () => import('@/views/assessment/rejected-with-recommend/index.vue'),
  },
  /**
   * 审核结果中转页
   * 用于处理APP跳转审核状态
   */
  {
    path: '/assessment/app-relay',
    meta: {
      title: '审核结果',
    },
    component: () => import('@/views/assessment/app-relay.vue'),
  },
  /**
   * 一次风控授信审核出额页
   */
  {
    path: '/assessment/audit-pass',
    meta: {
      title: '我的额度',
      background: '#F5F5F5',
      customNavBar: true,
      excludeTracking: true,
    },
    component: () => import('@/views/assessment/audit-pass.vue'),
  },
] as RouteConfig[];
